export const tokens = {
  common: {
    languageChanged: "common.languageChanged",
  },
  nav: {
    auth: "nav.auth",
    create: "nav.create",
    dashboard: "nav.dashboard",
    details: "nav.details",
    edit: "nav.edit",
    error: "nav.error",
    files: "nav.files",
    forgotPassword: "nav.forgotPassword",
    list: "nav.list",
    login: "nav.login",
    mail: "nav.mail",
    overview: "nav.overview",
    profile: "nav.profile",
    register: "nav.register",
    resetPassword: "nav.resetPassword",
    editSite: "nav.editSite",
    editMeter: "nav.editMeter",
    readings: "nav.readings",
    graph: "nav.graph",
    dailyCons: "nav.dailyCons",
    monthlyCons: "nav.monthlyCons",
    sites: "nav.sites",
    settings: "nav.settings",
    jobSummary: "nav.jobSummary",
    logViewer: "nav.logViewer",
    logout: "nav.logout",
    loggerType: "nav.loggerType",
    telemetry: "nav.telemetry",
    administration: "nav.administration",
    roles: "nav.roles",
    users: "nav.users",
    changePassword: "nav.changePassword",
    audit: "nav.audit",
    stations: "nav.stations",
    rtus: "nav.rtus",
    waterQuality: "nav.waterQuality",
    hydrology: "nav.hydrology",
    alarms: "nav.alarms",
    reports: "nav.reports",
    inSituSampling: "nav.inSituSampling",
  },
  msg: {
    getSupport: "msg.getSupport",
    loginError: "msg.loginError",
    deleteSuccess: "msg.deleteSuccess",
    deleteFailed: "msg.deleteFailed",
    checkFormErrors: "msg.checkFormErrors",
    noRecordsFound: "msg.noRecordsFound",
    atLeastOneParameterRequired: "msg.atLeastOneParameterRequired",
  },
  label: {
    systemName: "label.systemName",
    email: "label.email",
    password: "label.password",
    forgetPassword: "label.forgetPassword",
    continue: "label.continue",
    systemShortName: "label.systemShortName",
    siteNameHint: "label.siteNameHint",
    siteName: "label.siteName",
    filters: "label.filters",
    dateRange: "label.dateRange",
    dateFrom: "label.dateFrom",
    dateTo: "label.dateTo",
    from: "label.from",
    to: "label.to",
    all: "label.all",
    sourcePoint: "label.sourcePoint",
    view: "label.view",
    districts: "label.districts",
    siteDetails: "label.siteDetails",
    siteCode: "label.siteCode",
    manufacturer: "label.manufacturer",
    modelNo: "label.modelNo",
    size: "label.size",
    startDate: "label.startDate",
    modemType: "label.modemType",
    partNo: "label.partNo",
    description: "label.description",
    firmwareVersion: "label.firmwareVersion",
    hardwareVersion: "label.hardwareVersion",
    powerSource: "label.powerSource",
    antennaType: "label.antennaType",
    coordinateX: "label.coordinateX",
    coordinateY: "label.coordinateY",
    elevation: "label.elevation",
    readings: "label.readings",
    datetime: "label.datetime",
    time: "label.time",
    editSite: "label.editSite",
    viewChart: "label.viewChart",
    noDataFound: "label.noDataFound",
    codeRequired: "label.codeRequired",
    nameRequired: "label.nameRequired",
    invalidPostcode: "label.invalidPostcode",
    siteUpdated: "label.siteUpdated",
    accountNo: "label.accountNo",
    address1: "label.address1",
    address2: "label.address2",
    address3: "label.address3",
    postcode: "label.postcode",
    city: "label.city",
    district: "label.district",
    editMeter: "label.editMeter",
    serialNo: "label.serialNo",
    meterType: "label.meterType",
    startRead: "label.startRead",
    endDate: "label.endDate",
    endRead: "label.endRead",
    update: "label.update",
    selectDistrict: "label.selectDistrict",
    selectMeterType: "label.selectMeterType",
    siteList: "label.siteList",
    siteSearch: "label.siteSearch",
    highestHourly: "label.highestHourly",
    yesterdayDiff: "label.yesterdayDiff",
    highestDaily: "label.highestDaily",
    monthDiff: "label.monthDiff",
    flowCount: "label.flowCount",
    runDate: "label.runDate",
    runStart: "label.runStart",
    runEnd: "label.runEnd",
    timeTaken: "label.timeTaken",
    totalData: "label.totalData",
    totalProcessed: "label.totalProcessed",
    runStatus: "label.runStatus",
    showProcessIncompleteOnly: "label.showProcessIncompleteOnly",
    complete: "label.complete",
    incomplete: "label.incomplete",
    nodata: "label.nodata",
    viewer: "label.viewer",
    timeTakenOpt1: "label.timeTakenOpt1",
    timeTakenOpt2: "label.timeTakenOpt2",
    timeTakenOpt3: "label.timeTakenOpt3",
    jobSummaryDesc: "label.jobSummaryDesc",
    operationDesc: "label.operationDesc",
    date: "label.date",
    result: "label.result",
    flowCountIncomplete: "label.flowCountIncomplete",
    sharpIncreaseFlowSma: "label.sharpIncreaseFlowSma",
    onlineSite: "label.onlineSite",
    offlineSite: "label.offlineSite",
    topConsumer: "label.topConsumer",
    topConsumerDesc: "label.topConsumerDesc",
    lastJobRun: "label.lastJobRun",
    nextJobRun: "label.nextJobRun",
    days: "label.days",
    hours: "label.hours",
    minutes: "label.minutes",
    editSftp: "label.editSftp",
    editMnHours: "label.editMnHours",
    configUpdated: "label.configUpdated",
    sftpHost: "label.sftpHost",
    sftpPort: "label.sftpPort",
    sftpUser: "label.sftpUser",
    sftpPw: "label.sftpPw",
    sftpRemoteDir: "label.sftpRemoteDir",
    mnStart: "label.mnStart",
    mnEnd: "label.mnEnd",
    sftpHostRequired: "label.sftpHostRequired",
    sftpPortRequired: "label.sftpPortRequired",
    sftpUserRequired: "label.sftpUserRequired",
    sftpRemoteDirRequired: "label.sftpRemoteDirRequired",
    active: "label.active",
    inactive: "label.inactive",
    address: "label.address",
    logType: "label.logType",
    logDate: "label.logDate",
    noLog: "label.noLog",
    allDistricts: "label.allDistricts",
    loggerTypeUpdated: "label.loggerTypeUpdated",
    descRequired: "label.descRequired",
    manufacturerRequired: "label.manufacturerRequired",
    parNoRequired: "label.parNoRequired",
    back: "label.back",
    editLoggerType: "label.editLoggerType",
    loggerDetails: "label.loggerDetails",
    createLoggerType: "label.createLoggerType",
    createSite: "label.createSite",
    selectLoggerType: "label.selectLoggerType",
    loggerSerialNo: "label.loggerSerialNo",
    loggerTypeRequired: "label.loggerTypeRequired",
    loggerSnRequired: "label.loggerSnRequired",
    errorOccurred: "label.errorOccurred",
    position: "label.position",
    districtRequired: "label.districtRequired",
    largeLogFile: "label.largeLogFile",
    clientName: "label.clientName",
    clientNameShort: "label.clientNameShort",
    roleName: "label.roleName",
    roleAccess: "label.roleAccess",
    actions: "label.actions",
    editRole: "label.editRole",
    language: "label.language",
    theme: "label.theme",
    moduleName: "label.moduleName",
    access: "label.access",
    roleFilterKey: "label.roleFilterKey",
    addRole: "label.addRole",
    moduleAccess: "label.moduleAccess",
    save: "label.save",
    scrollMore: "label.scrollMore",
    maxLength: "label.maxLength",
    minLength: "label.minLength",
    fieldRequired: "label.fieldRequired",
    roleUpdated: "label.roleUpdated",
    pressEnter: "label.pressEnter",
    name: "label.name",
    username: "label.username",
    fullName: "label.fullName",
    phone: "label.phone",
    role: "label.role",
    lastLogin: "label.lastLogin",
    createdDate: "label.createdDate",
    createdBy: "label.createdBy",
    modifiedDate: "label.modifiedDate",
    modifiedBy: "label.modifiedBy",
    userFilterKey: "label.userFilterKey",
    viewUser: "label.viewUser",
    editUser: "label.editUser",
    changePassword: "label.changePassword",
    addUser: "label.addUser",
    selectRole: "label.selectRole",
    passwordMin: "label.passwordMin",
    passwordMatches: "label.passwordMatches",
    confirmPassword: "label.confirmPassword",
    confirmPasswordMatches: "label.confirmPasswordMatches",
    invalidPhone: "label.invalidPhone",
    invalidPhoneExtra: "label.invalidPhoneExtra",
    validEmail: "label.validEmail",
    userUpdated: "label.userUpdated",
    selectOptionRequired: "label.selectOptionRequired",
    action: "label.action",
    allActions: "label.allActions",
    entityName: "label.entityName",
    allEntityNames: "label.allEntityNames",
    ipAddress: "label.ipAddress",
    userAgent: "label.userAgent",
    note: "label.note",
    beforeState: "label.beforeState",
    afterState: "label.afterState",
    reason: "label.reason",
    activate: "label.activate",
    deactivate: "label.deactivate",
    userStatusUpdated: "label.userStatusUpdated",
    passwordChangeSuccess: "label.passwordChangeSuccess",
    logoutNow: "label.logoutNow",
    export: "label.export",
    newPassword: "label.newPassword",
    stationFilterKey: "label.stationFilterKey",
    valueInNumber: "label.valueInNumber",
    addStation: "label.addStation",
    updateStation: "label.updateStation",
    viewStation: "label.viewStation",
    stationUpdated: "label.stationUpdated",
    stationName: "label.stationName",
    stationCode: "label.stationCode",
    location: "label.location",
    rtu: "label.rtu",
    selectRtu: "label.selectRtu",
    coordX: "label.coordX",
    coordY: "label.coordY",
    distanceToStation: "label.distanceToStation",
    getLocation: "label.getLocation",
    rtuUpdated: "label.rtuUpdated",
    addRTU: "label.addRTU",
    editRTU: "label.editRTU",
    viewRTU: "label.viewRTU",
    accessKey: "label.accessKey",
    getAccessKey: "label.getAccessKey",
    viewAccessKey: "label.viewAccessKey",
    brand: "label.brand",
    rtuStatusUpdated: "label.rtuStatusUpdated",
    rtuKeyUpdated: "label.rtuKeyUpdated",
    rtuKeyDesc: "label.rtuKeyDesc",
    close: "label.close",
    copyToClipboard: "label.copyToClipboard",
    copied: "label.copied",
    coordinate: "label.coordinate",
    stationStatusUpdated: "label.stationStatusUpdated",
    zoomIn: "label.zoomIn",
    viewDetails: "label.viewDetails",
    viewOutlets: "label.viewOutlets",
    addOutlet: "label.addOutlet",
    editOutlet: "label.editOutlet",
    viewOutlet: "label.viewOutlet",
    outletName: "label.outletName",
    regNo: "label.regNo",
    outletUpdated: "label.outletUpdated",
    outletStatusUpdated: "label.outletStatusUpdated",
    loading: "label.loading",
    threshold: "label.threshold",
    alert: "label.alert",
    paramName: "label.paramName",
    paramShortName: "label.paramShortName",
    paramUnit: "label.paramUnit",
    setLimit: "label.setLimit",
    warningLimit: "label.warningLimit",
    criticalLimit: "label.criticalLimit",
    thresholdUpdated: "label.thresholdUpdated",
    largerThanCritical: "label.largerThanCritical",
    largerThanWarning: "label.largerThanWarning",
    lessThanCritical: "label.lessThanCritical",
    lessThanWarning: "label.lessThanWarning",
    higherIsBetter: "label.higherIsBetter",
    lowerIsBetter: "label.lowerIsBetter",
    alertEmailUpdated: "label.alertEmailUpdated",
    updateEmail: "label.updateEmail",
    removeEmail: "label.removeEmail",
    removeEmailConfirm: "label.removeEmailConfirm",
    alertEmailRemoved: "label.alertEmailRemoved",
    outlet: "label.outlet",
    selectMukim: "label.selectMukim",
    mukim: "label.mukim",
    note1: "label.note1",
    stationOverview: "label.stationOverview",
    stationOverviewDesc: "label.stationOverviewDesc",
    stationCloseUp: "label.stationCloseUp",
    stationCloseUpDesc: "label.stationCloseUpDesc",
    stationOptional: "label.stationOptional",
    stationOptionalDesc: "label.stationOptionalDesc",
    noPicture: "label.noPicture",
    ssmNo: "label.ssmNo",
    outletOverview: "label.outletOverview",
    outletOverviewDesc: "label.outletOverviewDesc",
    outletCloseUp: "label.outletCloseUp",
    outletCloseUpDesc: "label.outletCloseUpDesc",
    outletOptional: "label.outletOptional",
    outletOptionalDesc: "label.outletOptionalDesc",
    delete: "label.delete",
    deleteOutlet: "label.deleteOutlet",
    deleteOutletConfirm: "label.deleteOutletConfirm",
    outletRemoved: "label.outletRemoved",
    detailInfo: "label.detailInfo",
    samplingData: "label.samplingData",
    samplingDate: "label.samplingDate",
    readingDate: "label.readingDate",
    parameters: "label.parameters",
    missingData: "label.missingData",
    stationInfo: "label.stationInfo",
    reading: "label.reading",
    exportToExcel: "label.exportToExcel",
    station: "label.station",
    displayReading: "label.displayReading",
    readingData: "label.readingData",
    noDataToDisplay: "label.noDataToDisplay",
    seeStation: "label.seeStation",
    seeAlarm: "label.seeAlarm",
    cleanRiver: "label.cleanRiver",
    slightlyPollutedRiver: "label.slightlyPollutedRiver",
    pollutedRiver: "label.pollutedRiver",
    alarmTriggered: "label.alarmTriggered",
    wqi: "label.wqi",
    wqiDesc: "label.wqiDesc",
    inSituWqi: "label.inSituWqi",
    inSituWqiDesc: "label.inSituWqiDesc",
    openStationOverview: "label.openStationOverview",
    hydro: "label.hydro",
    hydroDesc: "label.hydroDesc",
    compareTime: "label.compareTime",
    autoLoadStop: "label.autoLoadStop",
    autoLoadResume: "label.autoLoadResume",
    stopRefresh: "label.stopRefresh",
    refreshResume: "label.refreshResume",
    last5alarms: "label.last5alarms",
    wqiStationDesc: "label.wqiStationDesc",
    hydroStationDesc: "label.hydroStationDesc",
    map: "label.map",
    enterZenMode: "label.enterZenMode",
    exitZenMode: "label.exitZenMode",
    confirmLogout: "label.confirmLogout",
    cancel: "label.cancel",
    seeDashboard: "label.seeDashboard",
    generate: "label.generate",
    dailyReport: "label.dailyReport",
    monthlyReport: "label.monthlyReport",
    stationSourcePointList: "label.stationSourcePointList",
    alarmReport: "label.alarmReport",
    month: "label.month",
    selectStationAndParameter: "label.selectStationAndParameter",
    selectAll: "label.selectAll",
    deselectAll: "label.deselectAll",
    dailyAlarmReport: "label.dailyAlarmReport",
    monthlyAlarmReport: "label.monthlyAlarmReport",
    monthlyReportSummary: "label.monthlyReportSummary",
    dailyReportSummary: "label.dailyReportSummary",
    expectedData: "label.expectedData",
    actualData: "label.actualData",
    percentageMissingData: "label.percentageMissingData",
    parameterDetails: "label.parameterDetails",
    yes: "label.yes",
    no: "label.no",
    totalExpectedData: "label.totalExpectedData",
    totalActualData: "label.totalActualData",
    totalMissingData: "label.totalMissingData",
    monthlyReportFileTitle: "label.monthlyReportFileTitle",
    dailyReportFileTitle: "label.dailyReportFileTitle",
    alarmDesc: "label.alarmDesc",
    monthlyAlarmReportFileTitle: "label.monthlyAlarmReportFileTitle",
    dailyAlarmReportFileTitle: "label.dailyAlarmReportFileTitle",
    dailyReadings: "label.dailyReadings",
    stationSourceReport: "label.stationSourceReport",
    stationDetails: "label.stationDetails",
    rtuSerialNo: "label.rtuSerialNo",
    rtuModelNo: "label.rtuModelNo",
    rtuBrand: "label.rtuBrand",
    stationSourceReportFileTitle: "label.stationSourceReportFileTitle",
    sample: "label.sample",
    keyWord: "label.keyWord",
    auditReportTitle: "label.auditReportTitle",
    alarmReportTitle: "label.alarmReportTitle",
    alarmCount: "label.alarmCount",
    alarmFrequency: "label.alarmFrequency",
    noAlarm: "label.noAlarm",
    low: "label.low",
    medium: "label.medium",
    high: "label.high",
    veryHigh: "label.veryHigh",
    alertEmailInstruction: "label.alertEmailInstruction",
    installedAt: "label.installedAt",
    sourcePointList: "label.sourcePointList",
    stationOutletName: "label.stationOutletName",
    sourcePointListSubtitle: "label.sourcePointListSubtitle",
    lastRefreshAt: "label.lastRefreshAt",
    emailToReceiveNotification: "label.emailToReceiveNotification",
    emailNotification: "label.emailNotification",
    currentWQI: "label.currentWQI",
    alarmCountByDate: "label.alarmCountByDate",
    rtuFilterKey: "label.rtuFilterKey",
    hasTwoSides: "label.hasTwoSides",
    upperLimit: "label.upperLimit",
    lowerLimit: "label.lowerLimit",
    largerThanUpperCritical: "label.largerThanUpperCritical",
    lessThanLowerCritical: "label.lessThanLowerCritical",
    acidity: "label.acidity",
    alkalinity: "label.alkalinity",
    lowerWarningLimit: "label.lowerWarningLimit",
    lowerCriticalLimit: "label.lowerCriticalLimit",
    upperWarningLimit: "label.upperWarningLimit",
    upperCriticalLimit: "label.upperCriticalLimit",
    kkmLimits: "label.kkmLimits",
    jasLimits: "label.jasLimits",
    sendCommandGrabSample: "label.sendCommandGrabSample",
    sendCommandGrabSampleConfirm: "label.sendCommandGrabSampleConfirm",
    commandSent: "label.commandSent",
    commandFailed: "label.commandFailed",
    seeCommandHistory: "label.seeCommandHistory",
    commandHistory: "label.commandHistory",
    mode: "label.mode",
    publicView: "label.publicView",
    publicViewDesc: "label.publicViewDesc",
    approvedBy: "label.approvedBy",
    approvedDate: "label.approvedDate",
    currentPublicView: "label.currentPublicView",
    toBeApprovedPublicView: "label.toBeApprovedPublicView",
    approve: "label.approve",
    wqiApproveSuccess: "label.wqiApproveSuccess",
    wqiApproveFailed: "label.wqiApproveFailed",
    approved: "label.approved",
    wqiCancelSuccess: "label.wqiCancelSuccess",
    wqiCancelFailed: "label.wqiCancelFailed",
    noWQIApproved: "label.noWQIApproved",
    dataMaintenance: "label.dataMaintenance",
    dataMaintenanceDesc: "label.dataMaintenanceDesc",
    rtuDataFile: "label.rtuDataFile",
    rtuDataFileDesc: "label.rtuDataFileDesc",
    uploadRTUFile: "label.uploadRTUFile",
    uploadRTUFileDesc: "label.uploadRTUFileDesc",
    fileExceedSize: "label.fileExceedSize",
    doNotCloseWindowWhileProcessing: "label.doNotCloseWindowWhileProcessing",
    startProcess: "label.startProcess",
    processCompleted: "label.processCompleted",
    processFailed: "label.processFailed",
    processInProgress: "label.processInProgress",
    addLocation: "label.addLocation",
    updateLocation: "label.updateLocation",
    locationInfo: "label.locationInfo",
    locationName: "label.locationName",
    locationCode: "label.locationCode",
    locationView: "label.locationView",
    uploadLocationView: "label.uploadLocationView",
    samplePoint: "label.samplePoint",
    uploadSamplePoint: "label.uploadSamplePoint",
    surrounding: "label.surrounding",
    uploadSurrounding: "label.uploadSurrounding",
    latestSamplingWQI: "label.latestSamplingWQI",
    latestSamplingDate: "label.latestSamplingDate",
    latestSamplingUpdatedBy: "label.latestSamplingUpdatedBy",
    sampleDate: "label.sampleDate",
    sampledBy: "label.sampledBy",
    analyzedBy: "label.analyzedBy",
    labReference: "label.labReference",
    remarks: "label.remarks",
    temperature: "label.temperature",
    latestReading: "label.latestReading",
    latestReadingDetails: "label.latestReadingDetails",
    wqiValue: "label.wqiValue",
    wqiValueHelper: "label.wqiValueHelper",
    readingsTabInfo: "label.readingsTabInfo",
    samplingHistory: "label.samplingHistory",
    editReading: "label.editReading",
    addReading: "label.addReading",
    addNewReading: "label.addNewReading",
    editReadingInfo: "label.editReadingInfo",
    readingUpdated: "label.readingUpdated",
    readingCreated: "label.readingCreated",
    exportDate: "label.exportDate",
    totalRecords: "label.totalRecords",
    exportSuccess: "label.exportSuccess",
    exportFailed: "label.exportFailed",
    errorLoadingData: "label.errorLoadingData",
    searchKeyword: "label.searchKeyword",
    dateRangeSampling: "label.dateRangeSampling",
    resetFilters: "label.resetFilters",

    // Inspection Report
    inspectionReport: "label.inspectionReport",
    inspectionReports: "label.inspectionReports",
    createInspectionReport: "label.createInspectionReport",
    editInspectionReport: "label.editInspectionReport",
    reportTitle: "label.reportTitle",
    reportDate: "label.reportDate",
    reportStatus: "label.reportStatus",
    reportNumber: "label.reportNumber",
    reportCode: "label.reportCode",
    fileNo: "label.fileNo",
    pollutionComplaint: "label.pollutionComplaint",
    licensingInspection: "label.licensingInspection",
    pdfPreview: "label.pdfPreview",
    inspectionReportPreview: "label.inspectionReportPreview",

    // Location Section
    addressLine1: "label.addressLine1",
    addressLine2: "label.addressLine2",
    addressLine3: "label.addressLine3",
    gpsCoordinates: "label.gpsCoordinates",
    latitude: "label.latitude",
    longitude: "label.longitude",

    // Officers Section
    officersInfo: "label.officersInfo",
    inspectionOfficers: "label.inspectionOfficers",
    selectInspectionOfficers: "label.selectInspectionOfficers",
    additionalOfficers: "label.additionalOfficers",
    additionalOfficersPlaceholder: "label.additionalOfficersPlaceholder",
    additionalOfficersHelper: "label.additionalOfficersHelper",
    selectOfficers: "label.selectOfficers",
    siteOfficer: "label.siteOfficer",
    siteOfficerName: "label.siteOfficerName",
    siteOfficerNamePlaceholder: "label.siteOfficerNamePlaceholder",
    siteOfficerPosition: "label.siteOfficerPosition",
    siteOfficerPhone: "label.siteOfficerPhone",
    siteOfficerEmail: "label.siteOfficerEmail",
    activityType: "label.activityType",

    // Schedule & Timing
    scheduleInfo: "label.scheduleInfo",
    inspectionDate: "label.inspectionDate",
    inspectionTime: "label.inspectionTime",

    // Findings Section
    findingsObservations: "label.findingsObservations",
    checkboxInstruction: "label.checkboxInstruction",
    enforcementInstruction: "label.enforcementInstruction",
    wasteDischarge: "label.wasteDischarge",
    dischargeSurfaceWater: "label.dischargeSurfaceWater",
    dischargePublicSewer: "label.dischargePublicSewer",
    dischargeStormDrain: "label.dischargeStormDrain",
    dischargeOther: "label.dischargeOther",
    specifyOther: "label.specifyOther",
    treatmentFacilities: "label.treatmentFacilities",
    preliminaryTreatment: "label.preliminaryTreatment",
    primaryTreatment: "label.primaryTreatment",
    secondaryTreatment: "label.secondaryTreatment",
    tertiaryTreatment: "label.tertiaryTreatment",
    noTreatment: "label.noTreatment",
    environmentalIssues: "label.environmentalIssues",
    odorComplaint: "label.odorComplaint",
    colorDischarge: "label.colorDischarge",
    foamFormation: "label.foamFormation",
    solidWaste: "label.solidWaste",
    oilGrease: "label.oilGrease",
    chemicalContainers: "label.chemicalContainers",
    siteConditions: "label.siteConditions",
    adequateDrainage: "label.adequateDrainage",
    properBunding: "label.properBunding",
    coveringStructure: "label.coveringStructure",
    securityFencing: "label.securityFencing",
    warningSignage: "label.warningSignage",
    compliance: "label.compliance",
    validLicense: "label.validLicense",
    planApproved: "label.planApproved",
    recordsMaintained: "label.recordsMaintained",
    previousNonCompliance: "label.previousNonCompliance",

    // New Findings Sections
    licensingDocuments: "label.licensingDocuments",
    treatmentSystem: "label.treatmentSystem",
    dischargePoint: "label.dischargePoint",
    parameterCompliance: "label.parameterCompliance",
    safetyAndCleanliness: "label.safetyAndCleanliness",
    enforcement: "label.enforcement",

    // a) Licensing/Documents items
    licenseCopyDisplayed: "label.licenseCopyDisplayed",
    licenseStillValid: "label.licenseStillValid",
    effluentPlanAvailable: "label.effluentPlanAvailable",
    maintenanceRecordsAvailable: "label.maintenanceRecordsAvailable",
    monitoringRecordsAvailable: "label.monitoringRecordsAvailable",
    labReportAvailable: "label.labReportAvailable",

    // b) Treatment System items
    treatmentSystemOperational: "label.treatmentSystemOperational",
    noDamageToComponents: "label.noDamageToComponents",
    clearSeparationEffluentRainwater: "label.clearSeparationEffluentRainwater",
    noBypassWithoutTreatment: "label.noBypassWithoutTreatment",
    chemicalsStoredProperly: "label.chemicalsStoredProperly",
    treatmentAreaClean: "label.treatmentAreaClean",

    // c) Discharge Point items
    dischargePointLabeled: "label.dischargePointLabeled",
    effluentFlowsApprovedChannel: "label.effluentFlowsApprovedChannel",
    noUncontrolledDischarge: "label.noUncontrolledDischarge",
    nearbyWaterNotPolluted: "label.nearbyWaterNotPolluted",
    samplingPointAccessible: "label.samplingPointAccessible",

    // d) Parameter Compliance items
    analysisShowsCompliance: "label.analysisShowsCompliance",
    correctiveActionTaken: "label.correctiveActionTaken",
    noUnauthorizedDischarge: "label.noUnauthorizedDischarge",

    // e) Safety and Cleanliness items
    safeAccessToTreatment: "label.safeAccessToTreatment",
    workersPPE: "label.workersPPE",
    noOpenChemicalDisposal: "label.noOpenChemicalDisposal",
    warningSignsPresent: "label.warningSignsPresent",

    // f) Enforcement items
    noticeSection70: "label.noticeSection70",
    noticeSection30: "label.noticeSection30",
    noticeSection77: "label.noticeSection77",
    noticeSection78: "label.noticeSection78",

    insituSamplingReport: "label.insituSamplingReport",
    serialNumber: "label.serialNumber",
    enterSerialNumber: "label.enterSerialNumber",
    noticeDetails: "label.noticeDetails",
    specifyDetails: "label.specifyDetails",
    samplingDataInNextSection: "msg.samplingDataInNextSection",
    reportCodeAutoGenerated: "msg.reportCodeAutoGenerated",
    uploadFile: "label.uploadFile",
    remove: "label.remove",

    // Sampling Section
    samplingInfo: "label.samplingInfo",
    sampleCollected: "label.sampleCollected",
    sampleId: "label.sampleId",
    collectionDateTime: "label.collectionDateTime",
    waterQualityParameters: "label.waterQualityParameters",
    dissolvedOxygen: "label.dissolvedOxygen",
    biochemicalOxygenDemand: "label.biochemicalOxygenDemand",
    chemicalOxygenDemand: "label.chemicalOxygenDemand",
    ammoniacalNitrogen: "label.ammoniacalNitrogen",
    suspendedSolids: "label.suspendedSolids",
    phLevel: "label.phLevel",
    waterQualityIndex: "label.waterQualityIndex",
    wqiClass: "label.wqiClass",
    labReport: "label.labReport",
    uploadLabReport: "label.uploadLabReport",
    labReportLatest: "label.labReportLatest",

    // Images Section
    siteImages: "label.siteImages",
    uploadImages: "label.uploadImages",
    maxImages: "label.maxImages",
    imageCaption: "label.imageCaption",

    // Summary Sections
    observationsSummary: "label.observationsSummary",
    recommendationsSummary: "label.recommendationsSummary",
    followUpActions: "label.followUpActions",
    maxCharacters: "label.maxCharacters",
    charactersRemaining: "label.charactersRemaining",

    // Actions & Status
    saveDraft: "label.saveDraft",
    continueEditing: "label.continueEditing",
    submitReport: "label.submitReport",
    generatePDF: "label.generatePDF",
    previewAndDownloadPDF: "label.previewAndDownloadPDF",
    markAsCompleted: "label.markAsCompleted",
    statusDraft: "label.statusDraft",
    statusCompleted: "label.statusCompleted",
    statusGenerated: "label.statusGenerated",
    lastSaved: "label.lastSaved",
    autoSave: "label.autoSave",

    // Validation Messages
    requiredField: "label.requiredField",
    invalidEmail: "label.invalidEmail",
    invalidCoordinates: "label.invalidCoordinates",
    selectAtLeastOne: "label.selectAtLeastOne",
    allParametersRequired: "label.allParametersRequired",
    pleaseFixRequiredFields: "label.pleaseFixRequiredFields",
    fileNumberRequired: "label.fileNumberRequired",
    reportDateRequired: "label.reportDateRequired",
    inspectionDateRequired: "label.inspectionDateRequired",
    inspectionTimeRequired: "label.inspectionTimeRequired",
    atLeastOneOfficerRequired: "label.atLeastOneOfficerRequired",
    siteOfficerNameRequired: "label.siteOfficerNameRequired",
    stationRequired: "label.stationRequired",
    sourcePointRequired: "label.sourcePointRequired",
    addressLine1Required: "label.addressLine1Required",
    sampleIdRequiredWhenCollected: "label.sampleIdRequiredWhenCollected",
    sampleDateRequiredWhenCollected: "label.sampleDateRequiredWhenCollected",
    viewInspectionReports: "label.viewInspectionReports",
    pdfGenerated: "label.pdfGenerated",
    preview: "label.preview",
    inspectionSummaryRequired: "label.inspectionSummaryRequired",
    followUpActionsRequired: "label.followUpActionsRequired",
    actionConfirmationRequired: "label.actionConfirmationRequired",
    siteVisitDate: "label.siteVisitDate",
    siteVisitTime: "label.siteVisitTime",
    officers: "label.officers",
    activity: "label.activity",
    created: "label.created",
    updated: "label.updated",
    reportType: "label.reportType",
  },
};
